import dayjs from "dayjs";
import {buscarReservacionesDiaHora} from "../Reservas/buscarReservacionesDiaHora";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

export const buscarMesasDisponiblesDiaHora = async ({fecha, hora, tiempo = 1}) => {

    let fechaUnificada = new Date(fecha).setHours(new Date(hora).getHours(), new Date(hora).getMinutes(), 0, 0);
    let fechaInicio = new Date(fechaUnificada).getTime()
    let fechaFin = new dayjs(fechaInicio).add(tiempo, 'hours');

    let reservaciones = await buscarReservacionesDiaHora({fechaInicio: fechaInicio, fechaFin: fechaFin.valueOf()});

    let doxMesas = await obtenerCol('mesas')
    let mesas = doxMesas.data

    let arr = []

    for (let i = 0; i < mesas.length; i++) {

        let index = reservaciones.findIndex((e) => e.idMesa === mesas[i].id)


        if (index === -1) {
            let obj = {...mesas[i]}
            arr.push(obj)
        }


    }

    console.log(reservaciones)
    console.log(mesas)

    return arr


}